module.exports = __webpack_public_path__ + "img/clinic.6d0bb6f3.svg";